import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
} from '@angular/core';
import { InputRadioElementItem } from '../../types/input-radio-element-item.type';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';
import { ColorService } from '../../services/color.service';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';

@Component({
  selector: 'app-input-radio-element',
  imports: [ReactiveFormsModule, NgClass, IconComponent, TranslateModule, UpperFirstLetterPipe],
  templateUrl: './input-radio-element.html',
  styleUrls: ['./input-radio-element.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputRadioElement<T> {
  private colorService: ColorService = inject(ColorService);
  readonly elementsList: InputSignal<InputRadioElementItem<T>[]> =
    input.required<InputRadioElementItem<T>[]>();
  readonly selectedValue: InputSignal<T | null | undefined> = input<T | null | undefined>();
  readonly disabled: InputSignal<boolean> = input<boolean>(false);
  valueChange: OutputEmitterRef<T> = output<T>();
  defaultOptionName: T | null = null;
  form: FormGroup = new FormGroup({});
  textColor: string = this.colorService.getCssVariable('--text-color');
  textColor500: string = this.colorService.getCssVariable('--neutral-500');

  ngOnInit(): void {
    this.form.get('contentType')?.valueChanges.subscribe((value: T) => {
      this.valueChange.emit(value);
    });
  }

  ngOnChanges(): void {
    const defaultOption: InputRadioElementItem<T> | undefined = this.elementsList().find(
      (el: InputRadioElementItem<T>) => el.default === true,
    );
    this.defaultOptionName = defaultOption ? defaultOption.value : null;
    const selectedValue: T | null | undefined = this.selectedValue();
    const initialValue: T | null = selectedValue ?? this.defaultOptionName ?? null;

    if (this.form && this.form.get('contentType')) {
      this.form.get('contentType')?.setValue(initialValue, { emitEvent: false });
    } else {
      this.form = new FormGroup({
        contentType: new FormControl(initialValue),
      });
    }

    if (this.disabled()) this.form.get('contentType')?.disable({ emitEvent: false });
  }
}
